import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Servicos from './components/Servicos';
import Sobre from './components/Sobre';
import Galeria from './components/Galeria';
import Contato from './components/Contato';
import Footer from './components/Footer';
import SeoHead from './components/SeoHead';

const HomePage = () => (
  <div className="bg-[#0d0d0d] min-h-screen">
    <SeoHead />
    <Navbar />
    <main>
      <Hero />
      <Servicos />
      <Sobre />
      <Galeria />
      <Contato />
    </main>
    <Footer />

    {/* Floating WhatsApp Button */}
    <a
      href="https://wa.me/5511954283481?text=Ol%C3%A1%2C%20tenho%20interesse%20nos%20servi%C3%A7os%20de%20drone"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full shadow-2xl shadow-green-900/50 transition-all duration-200 hover:scale-110 cursor-pointer"
      aria-label="Falar no WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl"></i>
    </a>
  </div>
);

export default HomePage;
